/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignatureParticipantResponseDto } from './signatureParticipantResponseDto.model';
import { SigningMethod } from './signingMethod.model';


export interface ContractSignatureParticipantsDto { 
    allowedSigningMethods: Array<SigningMethod>;
    defaultSigningMethod?: SigningMethod | null;
    participants: Array<SignatureParticipantResponseDto>;
}
export namespace ContractSignatureParticipantsDto {
}


